module.exports = __webpack_public_path__ + "img/max-file-add--json.96d712f1.svg";